import React from 'react';
import PropTypes from 'prop-types';
import { APP } from 'appenv';
import BoothProfileTabsContainer from './components/BoothProfileTabsContainer';
import Booth618ProfileTabsContainer from './templates/Booth618Template/BoothProfileTabsContainer';
import Booth623ProfileTabsContainer from './templates/Booth623Template/BoothProfileTabsContainer';
import Booth624ProfileTabsContainer from './templates/Booth624Template/BoothProfileTabsContainer';
import Booth711ProfileTabsContainer from './templates/Booth711Template/BoothProfileTabsContainer';
import Booth710ProfileTabsContainer from './templates/Booth710Template/BoothProfileTabsContainer';

const BoothProfileTabsContainerTemplateSwitch = ({ booth, isDesktop }) => {
  switch (APP) {
    case 'ms624':
      return <Booth624ProfileTabsContainer booth={booth} isDesktop={isDesktop} />;
    case 'paloalto623':
      return <Booth623ProfileTabsContainer booth={booth} isDesktop={isDesktop} />;
    case 'polyu618':
      return <Booth618ProfileTabsContainer booth={booth} isDesktop={isDesktop} />;
    case 'scmp711':
      return <Booth711ProfileTabsContainer booth={booth} isDesktop={isDesktop} />;
    case 'lighthouse710':
      return <Booth710ProfileTabsContainer booth={booth} isDesktop={isDesktop} />;
    default:
      return <BoothProfileTabsContainer booth={booth} isDesktop={isDesktop} />;
  }
};

BoothProfileTabsContainerTemplateSwitch.propTypes = {
  booth: PropTypes.shape({
    id: PropTypes.number.isRequired,
    attachments: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    socialMedias: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    emailContacts: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    phoneContacts: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    name: PropTypes.string.isRequired,
    boothNumber: PropTypes.string,
    description: PropTypes.string.isRequired,
    website: PropTypes.string.isRequired,
    extraFields: PropTypes.shape().isRequired,
    industryVerticals: PropTypes.shape().isRequired,
    fundingStage: PropTypes.string.isRequired,
    coreTechnology: PropTypes.string,
    hashtags: PropTypes.string,
    oneLiner: PropTypes.string,
  }).isRequired,
  isDesktop: PropTypes.bool.isRequired,
};

export default BoothProfileTabsContainerTemplateSwitch;
